import IconButtonTsoPq from '@components/Buttons/IconButtonTsoPq';
import ModalDialogTsoPq from '@components/ModalDialog/ModalDialogTsoPq';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { GridColDef } from '@mui/x-data-grid-pro';
import {
  useGetVoltageLevelByIdHasDataQuery,
  useGetVoltageLevelByIdIsReferencedQuery,
  useGetVoltageLevelGetAllQuery,
} from '@redux/apiSlices/voltageLevelApi';
import { skipToken } from '@reduxjs/toolkit/query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import GenericGridPage from '../GenericGridPageProps';
import { StyledEditIconWrapper } from '../StyledGridPageComponents';
import VoltageLevelModal from './VoltageLevelModal';

export type RowDataVoltageLevel = {
  id: number;
  name: string;
  value: number;
  comment?: string;
};

const VoltageLevel = () => {
  const { t } = useTranslation();

  const [showModal, setShowModal] = useState(false);
  const [addNew, setAddNew] = useState(false);
  const [selected, setSelected] = useState<RowDataVoltageLevel | null>(null);

  const { data: rows } = useGetVoltageLevelGetAllQuery();
  const { data: hasData } = useGetVoltageLevelByIdHasDataQuery(selected?.id ?? skipToken, { skip: !selected });
  const { data: isReferenced } = useGetVoltageLevelByIdIsReferencedQuery(selected?.id ?? skipToken, {
    skip: !selected,
  });
  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: `${t('masterdata.voltageLevel.table.voltageLevelName')}`,
      width: 200,
      headerClassName: 'customBackgroundHeader',
      resizable: true,
    },
    {
      field: 'valueInKilovolt',
      headerName: `${t('masterdata.voltageLevel.table.voltageLevelValue')}`,
      width: 200,
      headerClassName: 'customBackgroundHeader',
      resizable: true,
    },
    {
      field: 'comment',
      headerName: `${t('masterdata.voltageLevel.table.comment')}`,
      flex: 1,
      width: 950,
      headerClassName: 'customBackgroundHeader',
      resizable: true,
    },
    {
      field: 'edit',
      headerName: '',
      width: 50,
      headerClassName: 'customBackgroundHeader',
      sortable: false,
      filterable: false,
      resizable: true,
      renderCell: (params) => (
        <StyledEditIconWrapper>
          <IconButtonTsoPq
            sizeVariant="s"
            buttonType="inputIconPrimary"
            icon={faPen}
            onClick={(e) => {
              e.stopPropagation();
              setShowModal(true);
              setSelected(params.row);
            }}
          />
        </StyledEditIconWrapper>
      ),
    },
  ];

  const modal =
    (showModal && (
      <ModalDialogTsoPq modalState={showModal}>
        <VoltageLevelModal
          newVoltageLevel={addNew}
          handleDiscard={() => {
            setShowModal(false);
            setAddNew(false);
            setSelected(null);
          }}
          updateDisabled={hasData}
          deleteDisabled={isReferenced}
          selectedVoltageLevel={selected || undefined}
          defaultValues={selected || {}}
        />
      </ModalDialogTsoPq>
    )) ||
    null;

  return (
    <GenericGridPage
      title={`${t('masterdata.voltageLevel.section')}`}
      rows={rows?.externalDtos ?? []}
      columns={columns}
      onAddClick={() => {
        setShowModal(true);
        setAddNew(true);
      }}
      modalComponent={modal}
      searchLabel={t('searchfield.search')}
      sortModel={[{ field: 'name', sort: 'asc' }]}
    />
  );
};

export default VoltageLevel;
